import { forwardRef, useImperativeHandle } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import '../../views/ServiceReport.css';
import '../forms/Button.css';
import { getLocalizedString, getLocalizedDateTime } from '../../localization/LocalizedString';

const sortByDate = (items) => {
  return items.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
};

const ExportIssuesExcelButton = forwardRef(({ currentLanguage, translate, data }, ref) => {
  const download = async () => {
    const sortedIssues = sortByDate(data);
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Sheet1');

    sheet.addRow([
      translate('service_report.column_issue.date'),
      translate('service_report.column_issue.type'),
      translate('service_report.column_issue.description'),
      translate('service_report.column_issue.customer'),
      translate('service_report.column_issue.end_customer'),
      translate('service_report.column_issue.address'),
      translate('service_report.column_issue.city'),
      translate('service_report.column_issue.service_site'),
    ]);

    sortedIssues.forEach((col) => {
      sheet.addRow([
        getLocalizedDateTime(new Date(col.createdAt), currentLanguage),
        getLocalizedString(col.type, currentLanguage),
        col.description || '',
        col.destination?.customer?.name || '',
        col.destination?.companyName || '',
        col.destination?.streetAddress || '',
        col.destination?.city || '',
        (col.serviceSiteNo || []).join(','),
      ]);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${translate('service_report.search.type_issue')}.xlsx`);
  };

  useImperativeHandle(ref, () => ({
    download,
  }));

  return null;
});

export default ExportIssuesExcelButton;
